import { createContext, useContext } from "react";
import { useLoadScript } from '@react-google-maps/api';
import { CountryContext } from "../contexts/CountryProvider";

export const MapsApiContext = createContext<{
    isLoaded: boolean,
    loadError?: {
        message: string
    }
}>({
    isLoaded: false
});

export const GoogleScriptWrapper = ({ children }: any) => {
    const country = useContext(CountryContext)

    if (!country || country === "CN") {
        return children;
    }

    return <GoogleScriptProvider>{children}</GoogleScriptProvider>
};

const GoogleScriptProvider = ({ children }: any) => {
    const context = useLoadScript({
        googleMapsApiKey: "AIzaSyC2mYcHLmvjBlmEwuWNs6JRfqV725kQW4M",
        libraries: ["places"],
        version: "3.51"
    });

    return (
        <MapsApiContext.Provider value={context}>
            {children}
        </MapsApiContext.Provider>
    )
}
